interface TutorialCardProps {
  title: string;
  description: string;
  duration: string;
  variant?: 'emerald' | 'dark';
  onWatch?: () => void;
}

export default function TutorialCard({ title, description, duration, variant = 'emerald', onWatch }: TutorialCardProps) {
  if (variant === 'dark') {
    return (
      <div className="bg-gray-900 dark:bg-gray-800 rounded-lg p-5 flex items-center justify-between">
        <div>
          <h3 className="text-white font-semibold text-sm">{title}</h3>
          <p className="text-gray-400 text-xs mt-0.5">{duration}</p>
        </div>
        <button
          onClick={onWatch}
          className="flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap"
        >
          <i className="ri-play-fill"></i>
          Watch Demo
        </button>
      </div>
    );
  }

  return (
    <div className="bg-gradient-to-r from-emerald-50 to-teal-50 dark:from-emerald-900/20 dark:to-teal-900/20 border border-emerald-200 dark:border-emerald-800 rounded-xl p-5 flex items-center justify-between">
      <div className="flex items-center gap-4">
        <div className="w-12 h-12 bg-emerald-500 rounded-xl flex items-center justify-center flex-shrink-0">
          <i className="ri-play-fill text-white text-xl"></i>
        </div>
        <div>
          <h3 className="text-sm font-semibold text-gray-900 dark:text-white">{title}</h3>
          <p className="text-xs text-gray-500 dark:text-gray-400">{duration} · {description}</p>
        </div>
      </div>
      <button
        onClick={onWatch}
        className="px-4 py-2 bg-emerald-600 text-white rounded-lg text-sm font-medium hover:bg-emerald-700 transition-colors whitespace-nowrap"
      >
        <i className="ri-play-circle-line mr-1.5"></i>
        Watch Demo
      </button>
    </div>
  );
}
